var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',{staticClass:"row"},[_c('Header')],1),_c('TabList'),_c('section',{staticClass:"tpui-container"},[_c('div',{staticClass:"row align-items-center mb-4"},[_c('div',{staticClass:"col-lg-12"},[_c('div',{staticClass:"grey-box p-3 pt-4"},[_c('Profile'),_c('Contact'),_c('Skill'),_c('Achievement')],1)])])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }